import axios from "axios";

const cr = axios.create({
  baseURL: process.env.REACT_APP_WEB_API_BASE_URL,
  withCredentials: true,
});

cr.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          window.location.href = "/";
          break;
        // case 500:
        //   window.location.href = "/servererror";
        //   break;
        default:
          return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default cr;
